export class QuarantineBatch {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "occurredAt",
            "baseName": "occurredAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "check",
            "baseName": "check",
            "type": "string",
            "format": ""
        },
        {
            "name": "reason",
            "baseName": "reason",
            "type": "string",
            "format": ""
        },
        {
            "name": "rowCount",
            "baseName": "rowCount",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return QuarantineBatch.attributeTypeMap;
    }
    constructor() {
    }
}
